import * as tslib_1 from "tslib";
import * as React from 'react';
import Compose from './Compose';
import ComposeCommandingBar from './ComposeCommandingBar';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import Dock from './Dock';
import { createInitialActions, executeInitialActions } from 'owa-initial-actions';
import floatCompose from 'owa-mail-compose-store/lib/actions/floatCompose';
import setAsyncSendState from 'owa-mail-compose-store/lib/actions/setAsyncSendState';
import strings from 'owa-strings/owa-mail-strings';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { observer } from 'mobx-react';
var styles = require('./FloatingCompose.scss');
var classNames = require('classnames/bind').bind(styles);
var FloatingCompose = /** @class */ (function (_super) {
    tslib_1.__extends(FloatingCompose, _super);
    function FloatingCompose(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickMinimizedTitle = function () {
            var composeViewState = _this.props.viewState.composeViewState;
            if (composeViewState.asyncSendState == 4 /* Sent */) {
                setAsyncSendState(composeViewState, 5 /* Closed */);
            }
            else {
                floatCompose(composeViewState, 0 /* Normal */);
            }
        };
        _this.initialActions = createInitialActions();
        return _this;
    }
    FloatingCompose.prototype.componentDidMount = function () {
        executeInitialActions(this.initialActions);
    };
    FloatingCompose.prototype.render = function () {
        var _a = this.props.viewState, type = _a.type, composeViewState = _a.composeViewState;
        var outerContainerClasses = '';
        var composePlugins = findComposePlugins(composeViewState);
        var scrollAdapter = composePlugins.dockingPlugin.getScrollAdapter();
        switch (type) {
            case 0 /* Normal */:
                outerContainerClasses = styles.floating;
                break;
            case 1 /* Minimized */:
                outerContainerClasses = classNames(styles.floating, styles.minimized);
                break;
            case 2 /* Maximized */:
                outerContainerClasses = classNames(styles.floating, styles.maximized);
                break;
        }
        return type == 1 /* Minimized */ ? (React.createElement("div", { className: outerContainerClasses }, this.renderMinimizedComposeTitle())) : (React.createElement("div", { className: outerContainerClasses },
            React.createElement(ComposeCommandingBar, { composeViewState: composeViewState, isFloatingCompose: true }),
            React.createElement("div", { className: styles.floatingBody },
                React.createElement(Compose, { viewState: composeViewState, className: classNames(styles.scrollContainer, 'customScrollBar'), initialActions: this.initialActions, ref: function (ref) { return scrollAdapter.setScrollContainer(ref ? ref.getRootDiv() : null); } }),
                React.createElement(Dock, { viewState: composeViewState, initialActions: this.initialActions }))));
    };
    FloatingCompose.prototype.renderMinimizedComposeTitle = function () {
        var asyncSendState = this.props.viewState.composeViewState.asyncSendState;
        switch (asyncSendState) {
            case 3 /* Timeout */:
                return (React.createElement("div", { onClick: this.onClickMinimizedTitle, className: styles.titleButtonBar },
                    React.createElement(Spinner, { className: styles.toastSpinner }),
                    strings.messageIsSendingTitle));
            case 2 /* Error */:
                return (React.createElement("div", { onClick: this.onClickMinimizedTitle, className: classNames(styles.titleButtonBar, styles.error) },
                    React.createElement(Icon, { iconName: "Error" /* Error */, className: styles.toastIcon }),
                    strings.messageSendingFailTitle));
            case 4 /* Sent */:
                return (React.createElement("div", { onClick: this.onClickMinimizedTitle, className: styles.titleButtonBar },
                    React.createElement(Icon, { iconName: "CheckMark" /* CheckMark */, className: styles.toastIcon }),
                    strings.messageIsSentTitle));
            default:
                return null;
        }
    };
    FloatingCompose = tslib_1.__decorate([
        observer
    ], FloatingCompose);
    return FloatingCompose;
}(React.Component));
export default FloatingCompose;
//# sourceMappingURL=FloatingCompose.js.map